import { render, staticRenderFns } from "./TermSection.vue?vue&type=template&id=24cb96d9&scoped=true&"
import script from "./TermSection.vue?vue&type=script&lang=js&"
export * from "./TermSection.vue?vue&type=script&lang=js&"
import style0 from "./TermSection.vue?vue&type=style&index=0&id=24cb96d9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cb96d9",
  null
  
)

export default component.exports